// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__11nck","tab":"ProcedureTabs_tab__3nJ8J"};